

import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { RouteReuseStrategy } from '@angular/router';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ComponentsModule } from './components/components.module';
import { SettingsService } from './services/settings.service';
import { AutoCloseOverlaysService } from './services/autoclose-overlays.service';
import { NgCalendarModule } from "ionic2-calendar"
import { DatePipe } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { Ionic4DatepickerModule } from '@logisticinfotech/ionic4-datepicker';
import { Storage, IonicStorageModule } from '@ionic/storage';
import { JwtModule, JWT_OPTIONS } from '@auth0/angular-jwt';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from 'src/environments/environment';
import { SignatureService } from './components/signature-pad/services/signature.service';
import { FolderService } from './components/folder/services/folder.service';
import { DirectiveModule } from './directives/directive.module';
import { ToastModule } from './components/toast';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';


export function jwtOptionsFactory(storage) {
  return {
    tokenGetter: () => {
      return storage.get('access_token');
    },
    whitelistedDomains: ['localhost:8080']
  };
}

@NgModule({
  declarations: [AppComponent],
  entryComponents: [],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    ToastModule.forRoot(),
    IonicModule.forRoot(),
    AppRoutingModule,
    FontAwesomeModule,
    ComponentsModule,
    NgCalendarModule,
    ComponentsModule,
    HttpClientModule,
    Ionic4DatepickerModule,
    IonicStorageModule.forRoot(),
    JwtModule.forRoot({
      jwtOptionsProvider: {
        provide: JWT_OPTIONS,
        useFactory: jwtOptionsFactory,
        deps: [Storage]
      }
    }),
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
    DirectiveModule,
    BrowserAnimationsModule
  ],
  providers: [
    StatusBar,
    DatePipe,
    SplashScreen,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    SettingsService,
    AutoCloseOverlaysService,
    SignatureService,
    FolderService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
